<template>
	<div class="relative hidden group-hover:block group-hover:absolute top-px left-[85%] md:left-full">
		<div class="flex gap-1">
			<slot></slot>
		</div>
	</div>
</template>
